import { SetTaskSorting } from './actionTypes'
import { UpdateTaskSorting } from './mutationTypes'

const actions = {
  async [SetTaskSorting]({ commit }, value) {
    commit(UpdateTaskSorting, value)
  }
}

export default actions
